import { Link } from "react-router-dom";
import { Zap, GraduationCap, Crown } from "lucide-react";

const AR_RUN = /([\u0600-\u06FF\u0750-\u077F][\u0600-\u06FF\u0750-\u077F\s\u064B-\u0670،؛]*)/g;
const arStyle = { fontFamily: "'Amiri', 'Scheherazade New', serif", fontSize: "1.25em", lineHeight: 1.7, letterSpacing: "normal", unicodeBidi: "isolate" };

function withArabic(text, key) {
    return text.split(AR_RUN).map((seg, j) => {
        if (!/[\u0600-\u06FF]/.test(seg)) return seg;
        const [, core, tail] = seg.match(/^([\s\S]*?)(\s*)$/);
        return <span key={`${key}-${j}`}><span style={arStyle} dir="rtl">{core}</span>{tail}</span>;
    });
}

export function isMostlyArabic(text) {
    const letters = (text || "").match(/\p{L}/gu) || [];
    return letters.length > 0 && letters.filter((c) => /[\u0600-\u06FF]/.test(c)).length / letters.length >= 0.5;
}

export function renderText(text, color = "var(--gold-200)") {
    return (text || "").split(/(\*\*[^*]+\*\*|\*[^*\n]+\*)/g).map((part, i) => {
        if (part.startsWith("**") && part.endsWith("**") && part.length > 4) return <strong key={i} style={{ color }}>{withArabic(part.slice(2, -2), i)}</strong>;
        if (part.startsWith("*") && part.endsWith("*") && part.length > 2) return <em key={i}>{withArabic(part.slice(1, -1), i)}</em>;
        return <span key={i}>{withArabic(part, i)}</span>;
    });
}

export function AssistantMessage({ message, intro = false }) {
    const isUser = message.role === "user";
    const rtl = isMostlyArabic(message.text);
    return (
        <div className={`flex ${isUser ? "justify-end" : "justify-start"}`} data-testid={intro ? "assistant-intro-msg" : `assistant-msg-${message.role}`}>
            <div
                dir={rtl ? "rtl" : "ltr"}
                className={`max-w-[85%] rounded-2xl px-3.5 py-2.5 leading-relaxed whitespace-pre-wrap ${rtl ? "text-base text-right" : "text-sm"}`}
                style={isUser
                    ? { background: "linear-gradient(135deg, var(--gold-300), var(--gold-500))", color: "#1A1208", borderBottomRightRadius: 6 }
                    : { background: "rgba(244,238,223,0.07)", color: "var(--text-on-dark)", border: "1px solid var(--border-dark)", borderBottomLeftRadius: 6 }}
            >
                {isUser ? <span style={rtl ? { ...arStyle, fontSize: "1.15em" } : undefined}>{message.text}</span> : renderText(message.text)}
                {message.source === "subscription" && (
                    <Link to="/abonnement" dir="ltr" className="btn-gold !py-2 !px-3 text-xs mt-3 inline-flex" data-testid="assistant-subscribe-link">
                        <Crown className="w-3.5 h-3.5" /> Voir l&apos;abonnement
                    </Link>
                )}
                {message.cached && (
                    <div dir="ltr" className="mt-2 flex items-center gap-1 text-[10px] uppercase tracking-wider" style={{ color: "var(--gold-300)" }} data-testid="assistant-cached-badge">
                        {message.source === "teacher"
                            ? <><GraduationCap className="w-3 h-3" /> Réponse validée par un professeur</>
                            : <><Zap className="w-3 h-3" /> Réponse instantanée</>}
                    </div>
                )}
            </div>
        </div>
    );
}
